import { UnicodeEntity } from '@mews/enums';
import { OptimusPlainLink, OptimusPlainLinkProps } from '@mews-commander/ui';

export interface EntityEditLinkProps {
    name: string;
    onEdit: OptimusPlainLinkProps['onClick'];
}

export default ({ onEdit, name }: EntityEditLinkProps) => (
    <OptimusPlainLink onClick={onEdit} inherit>
        {name || UnicodeEntity.Dash}
    </OptimusPlainLink>
);
